import $ from 'jquery';

// Generic Form - used as base class by CreateReviewForm
// 2026-10: this is GenericForm's's ONLY use.
export default class GenericForm {
  constructor($form) {
    this.$form = $form;
    if (!(this.$form && this.$form[0])) {
      return;
    }
  }

  formContents() {
    // 2026-10 ONLY use of serializeObject
    return this.$form.serializeObject();
  }

  errors() {
    console.log("Using default GenericForm.errors(), no validation");
    return {};
  }

  valid() {
    return _.size(this.errors()) === 0;
  }

  post(args = {}) {
    let url = args.url || this.url;

    args = _.extend({
      method: 'POST',
      url: url,
      success: (data, status, xhr) => this.onSuccess(data, status, xhr),
      fail: (xhr, status, err) => this.onFailure(xhr, status, err),
    }, args);

    args.data || (args.data = this.formContents());

    if (!url) {
      alert("url is blank");
      return false;
    }

    console.log(`Posting to ${url}`);

    // FIXME jquery ajax
    return $.ajax(args);
  }

  onSuccess(response, status, xhr) {
    console.log("GenericForm.onSuccess: " + JSON.stringify(response, null, 2));
    return window.response = response;
  }

  onFailure(xhr, status, err) {
    console.log("GenericForm.onFailure: " + JSON.stringify(response, null, 2));

    return alert("error submitting form: " + status + ": " + err);
  }

  displayErrors() {
    let errs, message;
    errs = this.errors();
    if (_.size(errs) > 0) {
      message = _(errs).values().join("\n \n");
      alert(message);
      return true;
    }
    return false;
  }
}
